<div class="certificate">

  <div class="certificate-image-container">
    <div class="certificate-value">{{this.certificate.amount + ' \u20AC'}}</div>
    <image class="certificate-image" [imageLink]="certificate.photo"></image>
  </div>

  <div class="certificate-info">

    <div class="certificate-info-text info-header">Подарочная карта на {{this.certificate.amount + ' \u20AC'}}</div>

    <div class="certificate-info-text">Дарить книги - всегда хорошая идея! Поэтому мы подготовили для вас
      подарочные сертификаты - получатель сможет выбрать свои уникальные истории!</div>
    <button mat-button class="order-button main-button" (click)="addToCart()">В корзину</button>

  </div>


</div>
